import NotInterestedIcon from '@/components/assets/NotInterestedIcon'
import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'

const CSILabels = ({ label, isSearch, isWebSearch }: { label: string; isSearch?: boolean; isWebSearch?: boolean }) => {
    return (
        <Flex>
            <Flex>
                <NotInterestedIcon
                    color={isWebSearch ? 'var(--chakra-colors-status-error)' : 'var(--chakra-colors-gray-800)'}
                    style={{ width: '13px', height: '18px', marginRight: '8px' }}
                />
                <Text
                    fontSize="12px"
                    fontFamily={!isSearch ? 'GSKPrecision-Bold' : 'inherit'}
                    letterSpacing="0.5px"
                    color={(() => {
                        if (isWebSearch) return 'var(--chakra-colors-status-error)'
                        if (isSearch) return 'var(--chakra-colors-gray-500)'
                        return 'default'
                    })()}
                >
                    {label}
                </Text>
            </Flex>
        </Flex>
    )
}

export default CSILabels
